<template>
    <div class="row">
        <notifications/>
        <form v-on:submit.prevent="handleBooking">
            <div class="col-md-12">
                <div class="row">
                    <div class="col-md-12">
                        <div class="row">
                            <div class="col-md-12">
                                <h3 class="h4">Your details:</h3>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label id="first_name">Agent name</label>
                                    <input name="first_name"
                                        id="first_name"
                                        class="form-control" 
                                        v-model="agentname"
                                        required>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Email</label>
                                    <input type="email" class="form-control" :value="agentDetails.email" disabled>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-12">
                                <div class="form-group">
                                    <label>Phone</label>
                                    <input class="form-control" :value="agentDetails.phone_number" disabled>
                                </div>
                            </div>
                        </div>
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Street address</label>
                                    <input class="form-control" :value="agentDetails.address_line_1" disabled>
                                </div>
                            </div>
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Address line 2 (optional)</label>
                                    <input class="form-control" :value="agentDetails.address_line_2" disabled>
                                </div>
                            </div>
                        </div>
            
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Town</label>
                                    <input class="form-control" :value="agentDetails.town_city" disabled>
                                </div>
                            </div>
            
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>County (optional)</label>
                                    <input class="form-control" :value="agentDetails.county" disabled>
                                </div>
                            </div>
                        </div>
            
                        <div class="row">
                            <div class="col-md-6">
                                <div class="form-group">
                                    <label>Postcode</label>
                                    <input class="form-control" :value="agentDetails.postcode" disabled>
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="box px-6 pt-4">
                            <h5>Do you have a voucher code?</h5>
                            <Discount :booking="$root.booking" :passenger-count="$root.passengerCount"></Discount>
                        </div>
                    </div>
                </div>
                <div class="row">
                    <div class="col-md-12">
                        <div class="box px-6 pt-4">
                            <div class="form-check">
                                <label>
                                    <input class="form-check-input" type="checkbox" v-model="termsConditions" required>
                                    I have provided to the customer the <a href="http://mistralholidays.co.uk/booking-conditions">Booking Conditions & Essential Information.</a>, which they have accepted.
                                </label>
                            </div>
                        </div>
                    </div>
                </div>
                <div class="row mt-3 mb-3">
                    <div class="col-md-12">
                        <button type="submit" class="btn btn-primary">Make Booking</button>
                    </div>
                </div>
            </div>
        </form>
        
    </div>
</template>

<script>
import axios from 'axios';
import Discount from './Discount';

export default {
    'name': 'AgentForm',   
    props :{
        agentDetails: {
            type: Object,
            required: true
        }
    },
    components: {
        Discount
    },
    computed: {
        totalAmount: function () {
            let totalAmount = this.$root.totalDeposit;
            if(this.paymentType == 'full') totalAmount = this.$root.totalCost;
            return totalAmount;
        }
    },
    data () {
        return {
            loginDetails: JSON.parse(localStorage.getItem('logged_in_user_credentials')),
            agentname:null,
            termsConditions: false,
        }
    },
    methods: {
        handleBooking() {
            if (this.$root.bookingResponse) {
                this.$router.push({ name: 'confirmation' })
            } else {
                this.$swal.fire({
                    title: 'Make Booking',
                    html: `
                     <div style="text-align: left; padding: 10px;">
                        <p>You are about to create a booking.</p>
                        <p style="margin-top: 15px; font-weight: bold;">Please note:</p>
                        <ul style="text-align: left; margin: 10px 0;">
                            <li>Customer will need to pay a deposit amount of ${this.$options.filters.formatCurrency(this.$root.totalDeposit)}</li>
                        </ul>
                        <p>Do you want to proceed?</p>
                    </div>
                `,
                    icon: 'info',
                    showCancelButton: true,
                    confirmButtonColor: '#3085d6',
                    cancelButtonColor: '#d33',
                    confirmButtonText: 'Confirm booking!',
                    cancelButtonText: 'Cancel'
                })
                    .then((result) => {
                        if (result.isConfirmed) {
                            this.createBooking()
                        }
                    })
            }
        },
        createBooking() {
            this.$root.loading = true
            var tourBookingRequest = []
            for (let item of this.$root.booking.tour_bookings) {
                var tour_booking = {
                tour_id: item.tour_id,
                tour_instance_id: this.$root.instance.id,
                tour_room_id: item.tour_room_id,
                rooms: Math.ceil( item.guests/item.room.occupancy ),
                guests: item.guests,
                price: item.price,
                cost: item.cost,
                passengers: item.passengers
                }
                tourBookingRequest.push(tour_booking)
            }

            var bookingRequest = {
                agent_id: this.agentDetails.id,
                agent_name : this.agentname,
                tour_bookings: tourBookingRequest,
                departure_date: this.$root.instance.departure_date,
                discount: this.$root.booking.discount,
                passenger_count: this.$root.passengerCount,
                extras:this.$root.booking.extras
            }

            this.$root.loading = true

            axios.post(this.$root.$api + 'agent/generate-booking', bookingRequest,
                {
                    headers: {
                        'Content-Type': 'application/json',
                        'Authorization': 'Bearer ' + this.loginDetails.access_token
                    }
                }
            )
            .then(res => res.data)
            .then(response => {
                this.errors = response.errors
                if(response.success) {
                    this.$root.bookingResponse = response.data;
                    window.location.href = `/my-profile#/booking/${response.data.id}`;
                } else if (response.errors) {
                    this.$root.loading = false
                    this.$notify({
                        type: 'error',
                        title: response.message
                    });
                }
            }).catch(error => {
                this.$root.loading = false;
                    console.log(error.response, 'sasa')
                    if(error.response.data.message) {
                    this.$notify({
                        type: 'error',
                        title: error.response.data.message
                    });
                }
            });
        }
    }    
}
</script>

<style scoped>
.modal-show{
    display: block !important;
}
</style>